import openModal from '@/modals/utils/openModal';

export const getClickHandler = (
  id: string,
  href: string | undefined,
  pathname: string,
  handleOpenSideBar: () => void,
  handleCloseSideBar: () => void,
  handleSupportClick: () => void,
) => {
  return () => {
    switch (id) {
      case 'menu':
        handleOpenSideBar();
        break;

      case 'online-support':
        handleSupportClick();
        break;

      case 'purchases':
        openModal('deposit');
        break;

      default:
        if (href === pathname) {
          handleCloseSideBar();
        }
        break;
    }
  };
};
